import { useMenu } from '@/hooks/useMenu'
import { useRouter } from 'next/router'
import React from 'react'

import { Container } from './styles'

// * Uma linha só: Home / categoria (discretos) / página atual (em destaque,
// * faz o papel de título).
export const SubHeader: React.FC = () => {
  const { active, resetActive } = useMenu()
  const router = useRouter()

  return (
    <Container className="no-print">
      {active && (
        <div className="breadcrumb-line">
          <button
            type="button"
            className="parent link"
            onClick={() => {
              router.push('/')
              resetActive()
            }}
          >
            Home
          </button>
          <span className="sep">/</span>
          {active.parent && (
            <>
              <span className="parent">{active.parent.title}</span>
              <span className="sep">/</span>
            </>
          )}
          <span className="current">{active.title}</span>
        </div>
      )}
    </Container>
  )
}
